import React, { useContext, useState } from 'react';
import { DataContext } from '../data/DataContext';
import { RadioButton, DropDown, CheckBox } from '../components'
import { catSiNo, catCardType } from '../data/MochaData'
import Modal from 'react-modal'

const StepAutomaticPayment = () => {
    const { IHContenidoSeguroCR, SetIHContenidoSeguroCR, ChangeHandler, ChangeHandler2 } = useContext(DataContext);
    const [modalTerm, setModalTerm] = useState(false);

    
    const styleModal = {
        overlay: { background: 'rgba(255, 255, 255, 0.85)' }
    }


    return (
        <>
            <RadioButton
                field='acceptSaveCard'
                label='¿Acepta la tarjeta que utilizó sea guardada para el pago de las cuotas siguientes?'
                onChangeStr={ChangeHandler2}
                catalog={catSiNo}
                value={IHContenidoSeguroCR.acceptSaveCard}
                onChange={() => { }}
            />
            {IHContenidoSeguroCR.acceptSaveCard === 'S' && <>
                <RadioButton
                    field='cardType'
                    label='Tipo de tarjeta'
                    onChange={() => { }}
                    onChangeStr={ChangeHandler2}
                    catalog={catCardType}
                    value={IHContenidoSeguroCR.cardType}
                />
                <DropDown
                    dataProvider={IHContenidoSeguroCR.catCountry}
                    field='cardCountry'
                    label='País de origen'
                    onChangeSelect={ChangeHandler2}
                    valueSelect={IHContenidoSeguroCR.cardCountry}
                />
                <DropDown
                    dataProvider={IHContenidoSeguroCR.catBank}
                    field='issuingBank'
                    label='Banco emisor'
                    onChangeSelect={ChangeHandler2}
                    valueSelect={IHContenidoSeguroCR.issuingBank}
                />
                <label style={{ color: '#4D4D4D', fontSize: '15px' }}>Recibirá el comprobante del medio de pago a estos datos en caso de haber autorizado el cambio.</label>
                <CheckBox
                    field='acceptCardTerm'
                    label='Acepto terminos y condiciones de uso'
                    onChange={ChangeHandler2}
                    value={IHContenidoSeguroCR.acceptCardTerm}
                    onClickLabel={() => setModalTerm(true)}
                />
            </>
            }
            <Modal isOpen={modalTerm} style={styleModal} className='modal'>
                <div className="mt20 mb-20" style={{ textAlign: 'justify', color: '#4D4D4D', paddingLeft: '10%', paddingRight: '10%', paddingTop: '20px', paddingBottom: '20px', fontSize: '15px' }} >
                    <p style={{ color: '#008866' }} ><strong>Terminos y Condiciones </strong> </p>
                    <p>Me comprometo a mantener mi tarjeta en condiciones aptas para que estos cargos automáticos puedan ser aplicados, de acuerdo a la periodicidad establecida.</p>
                    <p>Me comprometo a informar a Seguros <strong>LAFISE Costa Rica S.A.</strong>, en caso de cambio, de vencimiento o cualquier otra situación que impida aplicar los cargos autorizados.</p>
                    <p>En caso que mi póliza sea renovada, autorizo a <strong>Seguros LAFISE Costa Rica S.A.</strong> a continuar aplicando el(los) cargo(s), en la frecuencia y monto(s) que se establezcan en las condiciones particulares de la póliza vigente.</p>
                    <p>Acepto las condiciones presentes dentro de esta autorización y me comprometo a revisar los estados de cuenta, para verificar la aplicación del cargo.</p>
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-close" style={{ background: '#008866' }} onClick={() => setModalTerm(false)}>Cerrar</button>
                </div>
            </Modal>

        </>
    )
}

export { StepAutomaticPayment }